export default __webpack_public_path__ + "static/media/wiggle.08cf8153.png";